import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TagsInput } from "react-tag-input-component";
import { useSetRecoilState } from "recoil";
import { UpdateMasterClinicById, deleteDetailClinicById } from "../../../GQL/mutations";
import { globalLoadingScreenAtom } from "../../../shared/globalStates";
import { toastError, toastSuccess } from "../../../shared/helpers";
import { useGetMasterClinic } from "../../../shared/hooks/useGetMasterData";

function ModalDetailClinic(props) {
  const { detailClinic, modalDetailClinic, handleCloseModalDetailClinic } =
    props;
  const client = useApolloClient();
  const setIsLoading = useSetRecoilState(globalLoadingScreenAtom);
  const [listMasterClinic, fetchMasterClinic] = useGetMasterClinic();
  const [idDetail, setIdDetail] = useState([])
  const { disableButton, setDisableButton } = props;
  const [errInput, setErrInput] = useState(false)
  const [valueUpdateClinic, setValueUpdateClinic] = useState({
    id: null,
    clinic_name: "",
    clinic_branch: "",
    clinic_telp: "",
    clinic_address: "",
    clinic_email: [],
    clinic_detail: []
  });


  useEffect(() => {
    setIdDetail([])
    setValueUpdateClinic({
      id: detailClinic?.id,
      clinic_name: detailClinic?.clinic_name,
      clinic_branch: detailClinic?.clinic_branch,
      clinic_telp: detailClinic?.telp_number,
      clinic_address: detailClinic?.clinic_address,
      clinic_email: detailClinic?.detailClinic?.map(email => email.clinic_email),
      clinic_detail: detailClinic?.detailClinic
    });
  }, [modalDetailClinic]);


  const mergeDetailClinicEmail = (arrayVal) => {
    arrayVal.forEach((email) => {
      if (!detailClinic?.detailClinic.some((obj) => obj.clinic_email === email)) {
        detailClinic?.detailClinic.push({ clinic_email: email });
      } else {
        detailClinic.detailClinic = detailClinic?.detailClinic.filter(obj => arrayVal.includes(obj.clinic_email));
      }
    });
  }

  const deleteEmailClinic = async (IDs) => {
    try {
      const resp = await deleteDetailClinicById(client, IDs)
      if (resp.data.deleteDetailClinicById.status === "000") {
        toastSuccess("Email Deleted")
        fetchMasterClinic();
      } else {
        toastError(resp.data.deleteDetailClinicById.errMsg)
      }
    } catch (error) {
      toastError(error.message)
    }
  }


  const submitUpdateCLinic = async () => {
    if (
      valueUpdateClinic.clinic_name === "" ||
      valueUpdateClinic.clinic_branch === "" ||
      valueUpdateClinic.clinic_telp === "" ||
      valueUpdateClinic.clinic_address === "" ||
      valueUpdateClinic.clinic_email.length < 1
    ) {
      return setErrInput(true);
    }
    let paramUpdate = {
      id: detailClinic.id,
      clinic_name: valueUpdateClinic.clinic_name,
      clinic_branch: valueUpdateClinic.clinic_branch,
      clinic_address: valueUpdateClinic.clinic_address,
      telp_number: valueUpdateClinic.clinic_telp,
      detailClinicUpdateInput: detailClinic?.detailClinic?.map((detail) =>
      ({
        id: detail.id,
        clinic_email: detail.clinic_email
      }))
    }

    try {
      setIsLoading(true);

      deleteEmailClinic(idDetail)
      const responUpdate = await UpdateMasterClinicById(client, paramUpdate);
      if (responUpdate.data.updateMasterClinicById.errMsg === "OK") {
        toastSuccess("Clinic Updated")
        setIsLoading(false);
        fetchMasterClinic();
        handleCloseModalDetailClinic();
      } else {
        toastError(responUpdate.data.updateMasterClinicById.errMsg)
      }
    } catch (error) {
      toastError(error, "Error Update");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <React.Fragment>
      <Dialog open={modalDetailClinic} onClose={handleCloseModalDetailClinic} fullWidth maxWidth="sm" >
        <DialogTitle>Clinic Details</DialogTitle>
        <DialogContent>
          {/* <Button onClick={deleteEmailClinic}>Test API</Button> */}
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Name is required</p>
                }
                isError={errInput && !valueUpdateClinic.clinic_name}
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Clinic Name
                </label>
                <Input
                  defaultValue={detailClinic?.clinic_name}
                  type="text"
                  onChange={(e) => {
                    setValueUpdateClinic({
                      ...valueUpdateClinic,
                      clinic_name: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row mb-1">
            <div className="col-md-6">
              <FormGroup isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Branch is required</p>
                }
                isError={errInput && !valueUpdateClinic.clinic_branch}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Branch Name
                </label>
                <Input
                  type="text"
                  defaultValue={detailClinic?.clinic_branch}
                  onChange={(e) => {
                    setValueUpdateClinic({
                      ...valueUpdateClinic,
                      clinic_branch: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>No Telp is required</p>
                }
                isError={errInput && !valueUpdateClinic.clinic_telp}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  No telp
                </label>
                <Input
                  type="text"
                  defaultValue={detailClinic?.telp_number}
                  onChange={(e) => {
                    setValueUpdateClinic({
                      ...valueUpdateClinic,
                      clinic_telp: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Email is required</p>
                }
                isError={errInput && !valueUpdateClinic.clinic_email.length}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Clinic Email
                </label>
                <div style={{ fontSize: "13px" }}>
                  <TagsInput
                    value={valueUpdateClinic.clinic_email}
                    onRemoved={(val) => {
                      const filteredIDs = detailClinic.detailClinic
                        .filter(item => val.includes(item.clinic_email))
                        .map(item => item.id);

                      filteredIDs.map((ids) => {
                        setIdDetail([...idDetail, ids])
                        // deleteEmailClinic(ids)
                      })
                    }}
                    onChange={(e) => {
                      mergeDetailClinicEmail(e)
                      // setValueUpdateClinic({
                      //   ...valueUpdateClinic,
                      //   clinic_detail: { ...valueUpdateClinic.clinic_detail, clinic_email: e }
                      // });
                      setValueUpdateClinic({ ...valueUpdateClinic, clinic_email: e })
                      setDisableButton(false);
                    }}
                  />
                </div>
              </FormGroup>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12">
              <FormGroup isRequired placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Address is required</p>
                }
                isError={errInput && !valueUpdateClinic.clinic_address}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Address
                </label>
                <Input
                  type="text"
                  multiline
                  defaultValue={detailClinic?.clinic_address}
                  onChange={(e) => {
                    setValueUpdateClinic({
                      ...valueUpdateClinic,
                      clinic_address: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseModalDetailClinic}>
            Cancel
          </Button>
          <Button variant="contained" onClick={submitUpdateCLinic} disabled={disableButton}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalDetailClinic;
